import { render, staticRenderFns } from "./TheNotifications.vue?vue&type=template&id=d4a67702&"
import script from "./TheNotifications.vue?vue&type=script&lang=js&"
export * from "./TheNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports